import Button from "../../../Button";
import { useFormStore } from "../formStore";
import { Popover } from "@headlessui/react";
import { HelpCircle, Mail, X } from "react-feather";
import Image from "next/image";
import terminSVG from "/public/icons/light/figo_icon_light_aoc_termin.svg";
import kontaktSVG from "/public/icons/light/figo_icon_light_va_kontaktdaten.svg";
import buchenSVG from "/public/icons/light/figo_icon_light_va_projektdaten.svg";

const TitleStep = () => {
  const { getStep, prevStep, nextStep, data, setData } = useFormStore(
    (state) => ({
      getStep: state.getStep,
      prevStep: state.prevStep,
      nextStep: state.nextStep,
      data: state.data,
      setData: state.setData,
    })
  );

  const step = getStep();

  return (
    <div className="flex min-h-full flex-col justify-between">
      <div className="relative flex items-center justify-center bg-brand-turquoise-500 rounded-br-[5rem] py-[12rem]">
        <div className="absolute top-3 right-7">
          <Popover className="relative">
            <Popover.Button>
              <HelpCircle className="h-6 w-6" />
            </Popover.Button>

            <Popover.Overlay className="fixed inset-0 bg-white z-20" />

            <Popover.Panel className="fixed inset-x-0 z-20 top-[86px] bg-brand-turquoise-100 rounded-br-[5rem] overflow-y-auto">
              <div className="flex flex-col items-center justify-center bg-brand-turquoise-500 pb-14 rounded-br-[5rem] px-8">
                <div className="flex justify-end w-full mt-3">
                  <Popover.Button className="flex items-center">
                    Schließen <X className="h-6 w-6" />
                  </Popover.Button>
                </div>

                <div className="block items-start justify-center lg:flex lg:max-w-4xl lg:gap-2 pt-8">
                  <div className="flex items-start mb-10">
                    <div className="mr-4 flex-shrink-0 w-14 h-14">
                      <Image src={kontaktSVG} alt="Clock icon" width={56} height={56} />
                    </div>
                    <div className="flex-shrink text-left">
                      <h6 className="mb-2 text-white">1. Mitarbeiterwahl</h6>
                      <p className="text-body">Wählen Sie einen unserer Experten.</p>
                    </div>
                  </div>

                  <div className="flex items-start mb-10">
                    <div className="mr-4 flex-shrink-0 w-14 h-14">
                      <Image src={terminSVG} alt="Check list icon" width={56} height={56} />
                    </div>
                    <div className="flex-shrink text-left">
                      <h6 className="mb-2 text-white">2. Terminwahl</h6>
                      <p className="text-body">Bestimmen Sie Ihren Wunschtermin.</p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="mr-4 flex-shrink-0 w-14 h-14">
                      <Image src={buchenSVG} alt="Letter icon" width={56} height={56} />
                    </div>
                    <div className="flex-shrink text-left">
                      <h6 className="mb-2 text-white">3. Persönliche Angaben</h6>
                      <p className="text-body">
                        Hinterlegen Sie Ihre notwendigen Informationen.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col items-center justify-center px-8 pt-11 pb-16">
                <h6 className="mb-4">Sie benötigen Unterstützung?</h6>
                <p className="mb-8 text-body">Wir beraten Sie gern.</p>

                <div>
                  <a
                    href="mailto:anfrage@planmaschine.de"
                    className="mb-8 flex items-center"
                  >
                    <span className="mr-4 rounded-full border p-2 border-brand-blue-600">
                      <Mail className="h-5 w-5" />
                    </span>
                    <span>anfrage@planmaschine.de</span>
                  </a>
                </div>
              </div>
            </Popover.Panel>
          </Popover>
        </div>
        <div>
          <Image alt="logo" src={step.image.src} width={200} height={200} />
        </div>

        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 bg-brand-blue-600 py-7 px-12 rounded-[2.5rem] rounded-tr-none">
          <h5 className="whitespace-nowrap text-white">{step.title}</h5>
        </div>
      </div>

      <div className="mx-auto inline-flex items-center mt-8 py-10">
        <Button
          displayType={{ value: "button_primary" }}
          iconPosition={{ value: "right" }}
          onClick={nextStep}
        >
          Los geht's
        </Button>
      </div>
    </div>
  );
};

export default TitleStep;
